import React from "react";
import { Box } from "@chakra-ui/react";

interface CreditArgs {
    pixiv?: string
}

function credit({pixiv}: CreditArgs) {
    if(pixiv !== undefined) {
        return <a href={`https://www.pixiv.net/en/artworks/${pixiv}`}>Pixiv {pixiv}</a>
    } else {
        return "No source"
    }
}

interface CreditsArgs {
    type: string
    author: string
    pixiv?: string
}

const Credits = ({type,pixiv,author}: CreditsArgs) => {
    const creditLink = credit({pixiv})

   return <Box position="absolute" bottom="0" left="0" right="0" backgroundColor="rgba(255,255,255,0.5)">
       {type[0].toUpperCase() + type.slice(1)} by {author} {creditLink}
   </Box>
};

export default Credits